module.exports = __webpack_public_path__ + "static/media/villa.c00619a4.png";